// dependencies
import React from "react";

import Text from "../../../../../../components/Text";
import { CardBody, CardHeader } from "../../../../components/Card";
import QuestionsTable from "./QuestionsTable";
import QuestionsTableToolbar from "./QuestionsTableToolbar";

// hooks
import useQuestionTableRows, { SortableCol } from "./useQuestionTableRows";

// utils
import downloadCSV from "../../../../../../utils/downloadCSV";

import EmptySearchTableMessage from "../../../../../../pageTemplates/InfoPageTemplate/EmptySearchTableMessage";
// styles
import css from "./QuestionsTable.module.scss";

const QuestionsTableCard = () => {
	const [searchInput, setSearchInput] = React.useState("");
	const [sortField, setSortField] = React.useState<
		"factor" | "average_score" | "total_response_count" | "question_text"
	>("factor");
	const [sortDirection, setSortDirection] = React.useState<"desc" | "asc">("asc");

	const onSearchChanged = (searchTerm: string) => {
		if (searchTerm !== searchInput) {
			setSearchInput(searchTerm);
		}
	};

	const {
		rows,
		isLoading,
		getCSVContent,
		selectCSVDownloadName,
		handleDownloadQuestionAnswers,
		handleDownloadNPSAdditionalFeedback,
		getRowInformation,
	} = useQuestionTableRows(sortField, sortDirection, searchInput);

	const handleColumnClick = (columnId: SortableCol, direction: "asc" | "desc") => {
		setSortField(columnId);
		setSortDirection(direction);
	};

	const emptyTableState = <EmptySearchTableMessage mainText="No Questions Found" />;

	return (
		<>
			<CardHeader
				title={
					<Text element="span" size="paragraph-2" weight="semi-bold">
						All Questions
					</Text>
				}
				info="Filterable and searchable list of available satisfaction and engagement factor questions."
				toolBar={<QuestionsTableToolbar onSearch={onSearchChanged} additionalFeedbackQuestionEnabled={true} />}
				options={[
					{
						id: "download-csv",
						label: "Download CSV",
						action: () => {
							const csvContent = getCSVContent();
							const filename = selectCSVDownloadName();
							downloadCSV(csvContent ?? "", filename);
						},
					},
				]}
			/>
			<CardBody>
				<div className={css.cardBody}>
					<QuestionsTable
						rows={rows}
						isLoading={isLoading}
						sortDirection={sortDirection}
						sortField={sortField}
						handleColumnClick={handleColumnClick}
						handleDownloadQuestionAnswers={handleDownloadQuestionAnswers}
						getRowInformation={getRowInformation}
						handleDownloadNPSAdditionalFeedback={handleDownloadNPSAdditionalFeedback}
						emptyChildren={emptyTableState}
					/>
				</div>
			</CardBody>
		</>
	);
};

export default QuestionsTableCard;
